import React, { useState } from 'react';
import { toast } from 'sonner';
import { ShieldCheck, Loader2 } from 'lucide-react';
import { eaApi } from '../lib/api';

export const EAVerifyButton = ({ match, isItalian }) => {
  const [checking, setChecking] = useState(false);

  const verify = async () => {
    setChecking(true);
    try {
      const res = await eaApi.verifyMatch(match.match_id);
      const d = res.data;
      if (d.status === 'verified') {
        toast.success(d.message, { duration: 6000 });
      } else if (d.status === 'mismatch') {
        toast.error(d.message, { duration: 10000 });
      } else if (d.status === 'not_found') {
        toast.warning(d.message, { duration: 8000 });
      } else {
        toast.info(d.message, { duration: 6000 });
      }
    } catch (err) {
      toast.error(err?.response?.data?.detail || (isItalian ? 'Verifica EA fallita' : 'EA verify failed'));
    } finally {
      setChecking(false);
    }
  };

  return (
    <button
      className="flex items-center gap-1 px-2 py-1 bg-[#FFD700]/10 border border-[#FFD700]/30 text-[#FFD700] rounded text-[10px] uppercase tracking-wider font-bold hover:bg-[#FFD700]/20 transition-colors disabled:opacity-50"
      onClick={verify}
      disabled={checking}
      title={isItalian ? 'Verifica risultato su EA' : 'Verify result on EA'}
      data-testid={`ea-verify-btn-${match.match_id}`}
    >
      {checking ? <Loader2 size={12} className="animate-spin" /> : <ShieldCheck size={12} />}
      <span className="hidden sm:inline">EA</span>
    </button>
  );
};
